var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginSonifyIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M12.516 20.044 8.503 16.03H4.508a1.92 1.92 0 0 1-1.406-.592 1.92 1.92 0 0 1-.592-1.406v-3.995q0-.813.601-1.414.6-.6 1.414-.601h3.96l4.013-4.013.018 16.034zM14.46 3.25q3.093.69 5.056 3.129 1.962 2.44 1.962 5.621 0 3.183-1.962 5.622-1.963 2.44-5.056 3.129V18.7q2.246-.656 3.624-2.51A6.85 6.85 0 0 0 19.463 12a6.85 6.85 0 0 0-1.379-4.19q-1.38-1.857-3.624-2.51zm0 4.172a6.2 6.2 0 0 1 2.157 1.91 4.55 4.55 0 0 1 .848 2.686q0 1.485-.848 2.67a6.3 6.3 0 0 1-2.157 1.891v-2.404a4 4 0 0 0 .725-.99q.282-.548.283-1.15 0-.635-.274-1.192a3.8 3.8 0 0 0-.734-1.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M10.518 15.218v-6.4l-1.202 1.203H4.508v3.995h4.808z"
}))));
export default SvgPluginSonifyIcon;